@if (form.view) {
    @if (userService.isGranted('ROLE_PATROL_MANAGER')) {
        @if (form.view) {
            <form #formRef="ngForm" (ngSubmit)="submit()" @fadeInOut>
                <div class="row">
                    <sf-form
                        formClasses="col-md-6"
                        rowClasses="''"
                        name="community"
                        [view]="form.view"
                        [(ngModel)]="form.model"
                        (ngModelChange)="communityChanged($event)"
                        [fields]="['community']"
                    ></sf-form>
                    <sf-widget
                        class="col-md-6"
                        name="staff"
                        [view]="form.view.children['staff']"
                        [(ngModel)]="form.model['staff']"
                        [meta]="staffSearch"
                    ></sf-widget>
                    <sf-form formClasses="col-md-6" rowClasses="''" name="start" [view]="form.view" [(ngModel)]="form.model" [fields]="['start']"></sf-form>
                    <sf-form
                        formClasses="col-md-6"
                        rowClasses="''"
                        name="location"
                        [view]="form.view"
                        [(ngModel)]="form.model"
                        [fields]="['location']"
                    ></sf-form>
                </div>
                <div class="row">
                    <sf-form
                        formClasses="col-md-6"
                        rowClasses="''"
                        name="requiresReferral"
                        [view]="form.view"
                        [(ngModel)]="form.model"
                        [fields]="['requiresReferral']"
                    ></sf-form>
                </div>
                <label>Who was involved?</label>
                <div class="mb-4 pt-3">
                    <sf-form
                        formClasses="col-md-6"
                        rowClasses="''"
                        name="knownClients"
                        [view]="form.view"
                        [(ngModel)]="form.model"
                        [fields]="['knownClients']"
                    ></sf-form>
                </div>
                <div class="card mb-4 pt-3 px-3">
                    <sf-form name="form" [view]="form.view" [(ngModel)]="form.model" [fields]="['involved']"></sf-form>
                </div>
                <ngxh6-tabs
                    [splitIndex]="4"
                    [containerClass]="'tab-container p-4 mb-3'"
                    [navItems]="navItems"
                    [content]="tabContent"
                    [key]="'form-tab'"
                    [small]="true"
                ></ngxh6-tabs>
                <ng-template #tabContent let-id="id">
                    @if (id === 'reasons') {
                        <sf-form name="form1" [view]="form.view" [(ngModel)]="form.model" [fields]="['reason']"></sf-form>
                    }
                    @if (id === 'actions') {
                        <sf-form-action-entry
                            class="d-block mb-3"
                            name="actions"
                            [involved]="form.model['involved']"
                            [view]="form.view.children['actions']"
                            [(ngModel)]="form.model['actions']"
                        ></sf-form-action-entry>
                    }
                    @if (id === 'comments') {
                        <sf-form name="form3" [view]="form.view" [(ngModel)]="form.model" [fields]="['comments']"></sf-form>
                    }
                </ng-template>
                <sf-form name="form" [view]="form.view" [(ngModel)]="form.model" [fields]="['id', 'gpsLong', 'gpsLat']"></sf-form>
                @if (!options.sticky_actions && options.actions_separator) {
                    <hr />
                }
                <ngxh6-form-actions
                    [form]="form"
                    [options]="options"
                    [formRef]="formRef"
                    [valid]="formRef.valid"
                    (cancel)="cancel()"
                    (delete)="delete()"
                    (archive)="archive($event)"
                ></ngxh6-form-actions>
            </form>
        }
    }
    @if (!userService.isGranted('ROLE_PATROL_MANAGER')) {
        @if (form.view) {
            <form #formRef="ngForm" (ngSubmit)="submit()" @fadeInOut [class.dim]="form.saving || sliding">
                <ngb-carousel
                    #carousel
                    (slide)="sliding = true"
                    (slid)="sliding = false"
                    [class.sliding]="sliding"
                    [showNavigationArrows]="false"
                    [showNavigationIndicators]="false"
                    [wrap]="false"
                    [interval]="0"
                    [keyboard]="false"
                >
                    <ng-template ngbSlide [id]="'slide-0'">
                        <h5 class="font-weight-bold text-center mb-4 mt-3">Step 1. Why are we needed?</h5>
                        <sf-form-select-imagegrid
                            class="d-block mb-3 mx-3"
                            name="reason"
                            [view]="form.view.children['reason']"
                            [(ngModel)]="form.model['reason']"
                        ></sf-form-select-imagegrid>
                    </ng-template>
                    <ng-template ngbSlide [id]="'slide-1'">
                        <h5 class="font-weight-bold text-center mb-4 mt-3">Step 2. Who was involved?</h5>
                        <sf-form-involved
                            class="d-block mb-3"
                            name="involved"
                            [view]="form.view.children['involved']"
                            [(ngModel)]="form.model['involved']"
                        ></sf-form-involved>
                    </ng-template>
                    <ng-template ngbSlide [id]="'slide-2'">
                        <h5 class="font-weight-bold text-center mb-4 mt-3">Step 3. Was there any known clients?</h5>
                        <known-clients
                            class="d-block mb-3"
                            name="knownClients"
                            [view]="form.view.children['knownClients']"
                            [(ngModel)]="form.model['knownClients']"
                        ></known-clients>
                    </ng-template>
                    <ng-template ngbSlide [id]="'slide-3'">
                        <h5 class="font-weight-bold text-center mb-4 mt-3">Step 4. What did we do?</h5>
                        <sf-form-action-entry-simple
                            class="d-block mb-3"
                            name="actions"
                            [involved]="form.model['involved']"
                            [view]="form.view.children['actions']"
                            [(ngModel)]="form.model['actions']"
                        ></sf-form-action-entry-simple>
                    </ng-template>
                    <ng-template ngbSlide [id]="'slide-4'">
                        <h5 class="font-weight-bold text-center mb-4 mt-3">Step 5. Notes or comments</h5>
                        <sf-form-textarea name="form3" [view]="form.view.children['comments']" [(ngModel)]="form.model['comments']"></sf-form-textarea>
                        <hr />
                        <sf-form name="form" [view]="form.view" [(ngModel)]="form.model" [fields]="['requiresReferral']"></sf-form>
                        <sf-form name="form" [view]="form.view" [(ngModel)]="form.model" [fields]="['start']"></sf-form>
                    </ng-template>
                </ngb-carousel>
                <sf-form name="form" [view]="form.view" [(ngModel)]="form.model" [fields]="['id', 'gpsLong', 'gpsLat']"></sf-form>
                @if (!options.sticky_actions && options.actions_separator) {
                    <hr />
                }
                <div class="d-flex form-actions sticky py-2">
                    <button type="button" class="btn btn-gray" (click)="cancel()" [disabled]="sliding || form.saving">Close</button>
                    <div class="ms-auto">
                        @if (carousel.activeId !== 'slide-0') {
                            <button type="button" class="btn btn-primary me-5" (click)="changeSlide('prev')" [disabled]="sliding || form.saving">
                                <i class="fa fa-arrow-left me-2"></i>Back
                            </button>
                        }
                        @if (carousel.activeId !== 'slide-4') {
                            <button type="button" class="btn btn-primary" (click)="changeSlide('next')" [disabled]="sliding || form.saving">
                                Next<i class="fa fa-arrow-right ms-2"></i>
                            </button>
                        }
                        @if (carousel.activeId === 'slide-4') {
                            <button type="button" class="btn btn-primary" (click)="end()" [disabled]="sliding || form.saving">
                                <i class="fa fa-check me-2"></i>Done
                            </button>
                        }
                    </div>
                </div>
            </form>
        }
    }
} @else {
    @if (form.error) {
        <ngxh6-api-error [error]="form.error"></ngxh6-api-error>
        <div class="d-flex actions" [class.sticky]="options.sticky_actions">
            @if (options.show_back) {
                <input type="button" value="Back" (click)="location.back()" class="btn btn-gray" [disabled]="form.saving" />
            }
            @if (options.show_cancel) {
                <input type="button" value="Cancel" (click)="cancel()" class="btn btn-gray" [disabled]="form.saving" />
            }
        </div>
    } @else {
        <ngxh6-loading-spinner @fadeInOut></ngxh6-loading-spinner>
    }
}
